import {
  LOGGED_USER_KEY,
} from '../../types/user.types'

export default function () {
  return {
    [LOGGED_USER_KEY]: localStorage.getItem('user'),
  }
}
